<template lang="pug">
app-dialog( v-model="$_show" header="Добавить суд" width="800" )
  v-layout
    expert-court-form( ref="formCourt" :form.sync="form" )
  v-layout( column )
    v-checkbox( v-model="fillBankAccount" label="Заполнить банковские реквизиты" @change="switchBankAccountForm" ) 
    expert-bank-account-form( v-if="fillBankAccount" ref="formBankAccount" :form.sync="form.bankAccount" )
  .d-flex.flex-row-reverse
    app-button-action( @click="confirmSave()" ) Добавить
</template>

<script>
import { AppDialogToggable } from "@/components"
import ExpertCourtForm from "../forms/ExpertCourtForm.vue";
import ExpertBankAccountForm from '../forms/ExpertBankAccountForm.vue';
import { ExpertCourt } from "../models/ExpertCourt.model";
import { ExpertBankAccount } from '../models/ExpertBankAccount.model';

export default {
  name: "ExpertAddRegionDialog",
  mixins: [AppDialogToggable],

  components: {
    ExpertCourtForm,
    ExpertBankAccountForm
  },

  data() {
    return {
      form: new ExpertCourt(),
      fillBankAccount: false
    }
  },

  methods: {
    confirmSave() {
      let isValid = this.fillBankAccount ? this.$refs.formBankAccount.$refs.bankAccountForm.validate() : true
      if (this.$refs.formCourt.$refs.courtForm.validate() && isValid) {
        this.$emit('save', this.form)
        this.$_show = false
        this.fillBankAccount = false
        this.form = new ExpertCourt() 
      }
    },

    switchBankAccountForm() {
      if (this.fillBankAccount) {
        this.form.bankAccount = new ExpertBankAccount()
      }
    }
  }
}
</script>